/** Pone la primera letra en mayúscula. Vacío si la entrada es falsy. */
export const capitalize = (s: string | null | undefined): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '');
